<template lang="html">
  <div>register</div>
</template>

<script>
export default {
}
</script>

<style lang="css" scoped>
</style>
